import { Link } from 'react-router'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h1 className="text-9xl font-bold text-gray-300 mb-4">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">页面找不到了</h2>
          <p className="text-lg text-gray-600 mb-8">
            抱歉，您访问的页面不存在或已被移除。
            <br />
            请检查您输入的URL是否正确，或尝试其他页面。
          </p>
        </div>
        <div className="flex justify-center">
          <Link
            to="/"
            className="group relative px-6 py-3 border border-transparent text-lg font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors">
            <span className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-700 rounded-md opacity-0 group-hover:opacity-100 transition-opacity"></span>
            <span className="relative">返回首页</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
